module.exports = __webpack_public_path__ + "static/media/band_dos_orbitals.14ff8ecb.png";